<template>
<div class="user-wrapper">
  <div class="subpage__inner">
         <SubpageNav :links="links" class="DesktopTab"/>
    <div class="mobileTab" style="margin-top: 80px">
         <select-box :options="linkMobile" title="Hakkında"/>
    </div>
    <transition name="fade-up">
         <router-view/>
    </transition>
  </div>
</div>
</template>

<script>
import SubpageNav from '@/components/SubpageNav'
import SelectBox from '@/components/SelectBox'
//import axios from 'axios'
export default {
  name: 'DormUser',
  components: {
    SubpageNav, SelectBox
  },
  data () {
    return {
      links: [
        {
          id: 0,
          title: 'Account Information',
          to: { name: 'DormUserAccount' }
        },
        {
          id: 1,
          title: 'Statistics',
          to: { name: 'DormUserStatistic' }
        },
        {
          id: 2,
          title: 'Messages',
          to: { name: 'DormUserMessages' }
        },
        {
          id: 3,
          title: 'Movies',
          to: { name: 'DormUserDorms' }
        },
        {
          id: 4,
          title: 'Comments',
          to: { name: 'DormUserComments' }
        }
      ],
      linkMobile: [
        {
          name: 'Account Information'
        },
        {
          name: 'Statistics'
        },
        {
          name: 'Messages'
        },
        {
          name: 'Movies'
        },
        {
          name: 'Comments'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
@import "../assets/scss/components/user";
</style>
